import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { navLinks, siteInfo } from '@/mocks/site';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

const routeNameMap: Record<string, string> = {
  '': '首页',
  'category': '分类',
  'software': '电脑软件',
  'games': '热门游戏',
  'apps': '手机应用',
  'articles': '文章中心',
  'article': '文章详情',
  'about': '关于我们',
};

export function getBreadcrumbs(pathname: string): BreadcrumbItem[] {
  const segments = pathname.split('/').filter(Boolean);
  const crumbs: BreadcrumbItem[] = [{ label: '首页', href: '/' }];

  if (segments.length === 0) return crumbs;

  let currentPath = '';
  segments.forEach((seg, i) => {
    currentPath += `/${seg}`;
    const label = routeNameMap[seg] || seg;
    if (i < segments.length - 1) {
      crumbs.push({ label, href: currentPath });
    } else {
      crumbs.push({ label });
    }
  });

  return crumbs;
}

export default function Breadcrumb() {
  const location = useLocation();
  const [crumbs, setCrumbs] = useState<BreadcrumbItem[]>([]);

  useEffect(() => {
    setCrumbs(getBreadcrumbs(location.pathname));
  }, [location.pathname]);

  if (crumbs.length <= 1) return null;

  return (
    <nav aria-label="面包屑导航" className="bg-background-100 border-b border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {crumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <span className="mx-2 text-foreground-400">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {crumb.href ? (
                <Link
                  to={crumb.href}
                  className="text-foreground-500 hover:text-primary-600 transition-colors duration-200"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}